import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import { flatten, map } from '@beef/utils';
import { ScopeKeychain, useBeefCoExtend, useNodesContext } from '@beefco/sdk-shared';
import { cloneWithHashClass, useClassify } from '@beefco/lib-classify';
import { Mapper } from "../Mapper";
export var Renderer = function Renderer() {
  var createClass = useClassify();
  var _useNodesContext = useNodesContext(),
    getNode = _useNodesContext.getNode,
    rootNodeIds = _useNodesContext.rootNodeIds;
  var extendNode = useBeefCoExtend();
  var renderNode = function renderNode(nodeId, scopeKeychain) {
    var _getNode = getNode(nodeId
      // scopeKeychain,
      ),
      Component = _getNode.Component,
      active = _getNode.active,
      props = _getNode.props,
      styles = _getNode.styles,
      children = _getNode.children;
    if (!active) return false;
    if (Component === Mapper) {
      var _ref = props,
        value = _ref.value;
      /* children.children is not hardcode, since Mapper is built-in component */
      return flatten(value.map(function (scopeValue, index) {
        return children.children.reduce(function (accum, childId) {
          return [].concat(_toConsumableArray(accum), _toConsumableArray(renderNode(childId, scopeKeychain.cloneWithKey(nodeId, index)) || []));
        }, []);
      }));
    }
    var uniqueId = scopeKeychain.toUniqueId(nodeId);
    var ExtendedComponent = extendNode(Component);
    return [/*#__PURE__*/React.createElement(ExtendedComponent, _extends({}, props, map(children, function (childIds) {
      return childIds.map(function (childId) {
        return renderNode(childId, scopeKeychain);
      }).filter(Boolean);
    }), {
      className: cloneWithHashClass(props.className, createClass(uniqueId, styles)),
      extra: ExtendedComponent !== Component ? {
        nodeId: nodeId,
        uniqueId: uniqueId,
        scopeKeychain: scopeKeychain
      } : undefined
      // NOTE: this key will be used for a lot of good things, thus don't touch it
      ,
      key: "$beefco-uid:".concat(uniqueId, ":end$")
    }))];
  };
  return flatten(
  // @ts-expect-error FIXME: Some complicated things, fix it later
  rootNodeIds.map(function (childId) {
    return renderNode(childId, new ScopeKeychain());
  }).filter(Boolean));
};